import moment from 'moment'

const countDiff = (currentDate, endDate) => {

    let timeRemaining = moment.duration(endDate.diff(moment(currentDate)))

    let daysRemaining = timeRemaining.days()
    let hoursRemaining = timeRemaining.hours()
    let minutesRemaining  = timeRemaining.minutes()

    if(daysRemaining > 0 && hoursRemaining > 0) {
        daysRemaining += 1
    }

    if(daysRemaining > 14) {
        daysRemaining = 14
    }

    if(daysRemaining >= 1) {
        return daysRemaining + ' day' + (daysRemaining > 1 ? 's' : '')
    }

    if(hoursRemaining >= 1) {
        return hoursRemaining + ' hour' + (hoursRemaining > 1 ? 's' : '')
    }

    if(minutesRemaining > 0) {
        return minutesRemaining + ' minute' + (minutesRemaining > 1 ? 's' : '')
    }

    return 'ended'
}

export const getTrialTimeRemaining = (currentDate, dates) => {

    const endDate = moment(moment.utc(dates.endDate.seconds * 1000).format())

    return countDiff(currentDate, endDate)

}

export const isActionAfterAccecibleDate = (lastAccecibleDate, actionDate) => {
    if(!lastAccecibleDate || !actionDate) return
    return moment(actionDate).isAfter(moment(lastAccecibleDate.seconds*1000))
}